if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i === 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.#thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.#thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType === 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax === 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action === 'overlay' || KROWN.settings.cart_action === 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode === window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}
		}

		#thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i === index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media?.id ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
		}
	}

  if ( typeof customElements.get('product-page') === 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}

(function initSizeGuideUnitToggle() {
	const CM_PER_IN = 2.54;
	let uid = 0;

	const chartRoot = (el) => {
		return el.closest('.js-size-chart')
			|| el.closest('.product-size-guide-drawer')
			|| el.closest('.size-chart-container')
			|| el.closest('.card-widget__content');
	};

	const round1 = (x) => Math.round(x * 10) / 10;

	const cmTextToInText = (text) => {
		const t = String(text || '').replace(/\s+/g, '').trim();
		if ( ! t ) return '';
		const parts = t.split('-');
		if ( parts.length === 1 ) {
			const v = parseFloat(parts[0]);
			return isFinite(v) ? String(round1(v / CM_PER_IN)) : String(text);
		}
		if ( parts.length === 2 ) {
			const a = parseFloat(parts[0]);
			const b = parseFloat(parts[1]);
			if ( isFinite(a) && isFinite(b) ) {
				return String(round1(a / CM_PER_IN)) + '-' + String(round1(b / CM_PER_IN));
			}
		}
		return String(text);
	};

	const uniqueify = (root) => {
		['js-btn-cm', 'js-btn-in', 'js-unit-label', 'inches', 'centimeters'].forEach((id) => {
			root.querySelectorAll(`[id="${id}"]`).forEach((el) => {
				el.id = `${id}-${++uid}`;
			});
		});
	};

	const setEuUnit = (root, unit) => {
		const isCm = unit === 'cm';
		const btnCm = root.querySelector('[id="js-btn-cm"], [id^="js-btn-cm-"]');
		const btnIn = root.querySelector('[id="js-btn-in"], [id^="js-btn-in-"]');
		const unitLabel = root.querySelector('[id="js-unit-label"], [id^="js-unit-label-"]');

		if ( btnCm ) {
			btnCm.style.background = isCm ? '#111' : '#fff';
			btnCm.style.color = isCm ? '#fff' : '#111';
		}
		if ( btnIn ) {
			btnIn.style.background = isCm ? '#fff' : '#111';
			btnIn.style.color = isCm ? '#111' : '#fff';
		}
		if ( unitLabel ) unitLabel.textContent = isCm ? '(cm)' : '(in)';

		root.querySelectorAll('[data-unit="cm"]').forEach((el) => {
			el.style.display = isCm ? '' : 'none';
		});
		root.querySelectorAll('[data-unit="in"]').forEach((el) => {
			el.style.display = isCm ? 'none' : '';
		});
		root.querySelectorAll('.js-measure').forEach((td) => {
			const cm = td.getAttribute('data-cm') || '';
			td.textContent = isCm ? cm : cmTextToInText(cm);
		});
	};

	const setLegacyRows = (root, unit) => {
		const showInches = unit === 'inches';
		root.querySelectorAll('tr.inches').forEach((el) => {
			el.style.setProperty('display', showInches ? 'table-row' : 'none', 'important');
		});
		root.querySelectorAll('tr.centimeters').forEach((el) => {
			el.style.setProperty('display', showInches ? 'none' : 'table-row', 'important');
		});
		root.querySelectorAll('.sizechart__sublabel-text').forEach((el) => {
			const isCm = /cm|centimeter/i.test(`${el.id} ${el.textContent}`);
			el.classList.toggle('sizechart__sublabel--active', showInches ? !isCm : isCm);
		});
		root.setAttribute('data-size-unit-active', unit);
	};

	const isEuUnitButton = (el) => {
		if ( ! el || el.nodeType !== 1 ) return false;
		const id = el.id || '';
		if ( /^js-btn-(cm|in)(-|$)/.test(id) ) return true;
		return el.matches('[id="js-btn-cm"], [id="js-btn-in"], [id^="js-btn-cm-"], [id^="js-btn-in-"]');
	};

	const readyChart = (root) => {
		if ( ! root ) return;
		uniqueify(root);
		const btnCm = root.querySelector('[id="js-btn-cm"], [id^="js-btn-cm-"]');
		const btnIn = root.querySelector('[id="js-btn-in"], [id^="js-btn-in-"]');
		if ( btnCm && ! btnCm.dataset.unitBound ) {
			btnCm.dataset.unitBound = '1';
			btnCm.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				setEuUnit(chartRoot(btnCm) || root, 'cm');
			});
		}
		if ( btnIn && ! btnIn.dataset.unitBound ) {
			btnIn.dataset.unitBound = '1';
			btnIn.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				setEuUnit(chartRoot(btnIn) || root, 'in');
			});
		}
		if ( root.querySelector('.js-measure') ) setEuUnit(root, 'cm');
	};

	const onClick = (e) => {
		const start = e.target.nodeType === 1 ? e.target : e.target.parentElement;
		if ( ! start ) return;
		const root = chartRoot(start);
		if ( ! root ) return;

		const euBtn = start.closest('button');
		if ( euBtn && isEuUnitButton(euBtn) && root.contains(euBtn) ) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			setEuUnit(root, /^js-btn-in/.test(euBtn.id) ? 'in' : 'cm');
			return;
		}

		const legacyBtn = start.closest('.sizechart__sublabel-text, [id="inches"], [id="centimeters"], [id^="inches-"], [id^="centimeters-"]');
		if ( ! legacyBtn || ! root.contains(legacyBtn) ) return;
		if ( legacyBtn.closest('table') ) return;
		e.preventDefault();
		e.stopPropagation();
		const isCm = /cm|centimeter/i.test(`${legacyBtn.id} ${legacyBtn.textContent}`);
		setLegacyRows(root, isCm ? 'centimeters' : 'inches');
	};

	document.addEventListener('click', onClick, true);
	document.querySelectorAll('.js-size-chart, .product-size-guide-drawer').forEach(readyChart);
	document.addEventListener('size-guide:opened', (e) => {
		const drawer = e.target.closest ? (e.target.closest('.product-size-guide-drawer') || e.target) : e.target;
		readyChart(drawer.querySelector ? (drawer.querySelector('.js-size-chart') || drawer) : drawer);
	});

	window.__setUnit = function(unit) {
		document.querySelectorAll('.js-size-chart').forEach((root) => setEuUnit(root, unit === 'in' ? 'in' : 'cm'));
	};
})();